import * as React from 'react';
import { Text } from '@grandvisionhq/elements';

const RequiredActionMessage = ({ information , action  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, null, information), /*#__PURE__*/ React.createElement(Text, null, action))
;

export { RequiredActionMessage };
//# sourceMappingURL=RequiredActionMessage.js.map
